import React from 'react';

function ErrorBanner(props) {
  if (!props.message) {
    return null;
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <p className="error">
      <i className="material-icons md-24 md-light u-pull-left">error</i>
      {props.message}
    </p>
  );
}

export default ErrorBanner;
